import { Button, Grid, makeStyles, Typography } from '@material-ui/core';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import React from 'react';
import resume from '../assets/Diego Machado-Resume.pdf';
import me from '../assets/me.jpg';

const useStyles = makeStyles((theme) => ({
    root: {
        [theme.breakpoints.up('sm')]: {
            height: '100vh',
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: 100,
        },
    },
    subtitle: {
        fontWeight: 300,
        lineHeight: 1.6,
        margin: '10px 0',
        textAlign: 'left',
    },
    photo: {
        width: '100%',
        maxWidth: 350,
        borderRadius: 350,
        border: '5px solid #fff',
        margin: 'auto',
        boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 30px 0 rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
    },
    linkedIn: {
        background: '#007bb5',
    },
    twitter: {
        background: '#1da1f2',
    },
}));

const Bio = () => {
    const classes = useStyles();

    return (
        <Grid
            container
            direction='row'
            alignContent='center'
            justifyContent='center'
            spacing={3}
            className={classes.root}
            id='bio'
        >
            <Grid container alignContent='center' item xs={12} md={5}>
                <img src={me} alt='Diego Machado' className={classes.photo} />
            </Grid>
            <Grid container alignContent='center' item xs={12} md={7}>
                <Grid item xs={12}>
                    <Typography variant='h1' component='h1'>
                        Hello, I'm <br /> Diego Machado
                    </Typography>
                    <Typography
                        variant='h2'
                        component='h2'
                        className={classes.subtitle}
                    >
                        A brazilian Game Developer and self-taught Artist &amp;
                        Designer. <br />
                        Experienced in Unity3D, C# and Godot Engine.
                    </Typography>
                    <br />
                </Grid>
                <br />
                <Grid
                    container
                    spacing={1}
                    alignContent='center'
                    justifyContent='flex-start'
                    item
                    xs={12}
                >
                    <Grid item>
                        <Button
                            variant='contained'
                            color='primary'
                            startIcon={<AssignmentIndIcon />}
                            href={resume}
                        >
                            Curriculum Vitae
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            variant='contained'
                            color='primary'
                            startIcon={<LinkedInIcon />}
                            className={classes.linkedIn}
                            href='https://www.linkedin.com/in/diegomac'
                        >
                            LinkedIn
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            variant='contained'
                            color='primary'
                            startIcon={<TwitterIcon />}
                            className={classes.twitter}
                            href='https://www.twitter.com/diegomac'
                        >
                            Twitter
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Bio;
